module.exports = __webpack_public_path__ + "static/img/video-default.6cee93fc.svg";